'use client';
import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useCustomContext } from 'contexts/contextCreator';

interface ContextValue {
  canonical_url?: string;
}

export function CanonicalUrl() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const context = useCustomContext() as { value?: ContextValue };
  const canonicalUrlFromCMS = context?.value?.canonical_url || null;

  const getCanonicalPath = (basePath: string, currentPath: string): string => {
    if (currentPath.includes('/specification')) return `${basePath}/specification`;
    if (currentPath.includes('/compare')) return `${basePath}/compare`;
    return basePath;
  };

  useEffect(() => {
    if (!pathname) return;

    let canonicalHref: string;

    if (canonicalUrlFromCMS) {
      canonicalHref = getCanonicalPath(canonicalUrlFromCMS, pathname);
    } else {
      const baseUrl = `${window.location.origin}${pathname}`;
      canonicalHref = searchParams.size ? `${baseUrl}?${searchParams}` : baseUrl;
    }

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalHref);

    return () => {
      const existingLink = document.querySelector('link[rel="canonical"]');
      if (existingLink && existingLink.getAttribute('href') === canonicalHref) {
        existingLink.remove();
      }
    };
  }, [canonicalUrlFromCMS, pathname, searchParams]);

  return null;
}
